import { useEffect, useRef } from "react";
import { gnov } from "flowy-3-core";
import useZXing from "./useZXing";

function CodeScannerZXing({ config, onCapture }) {
  const { zxingReady, ZXing, error } = useZXing();
  const videoRef = useRef(null);

  useEffect(() => {
    if (zxingReady && ZXing && videoRef.current) {
      let codeReader;

      // By default we use QR code reader
      let readerType = "qr";
      const formats = gnov(config, "ops.textField.codeScanner.formats");
      if (formats) {
        if (formats.includes("qr_code") && formats.includes("code_128")) {
          readerType = "both";
        } else if (formats.includes("code_128")) {
          readerType = "barcode";
        }
      }

      const startScanning = async () => {
        try {
          if (readerType === "both") {
            codeReader = new ZXing.BrowserMultiFormatReader();
          } else if (readerType === "barcode") {
            codeReader = new ZXing.BrowserMultiFormatOneDReader();
          } else {
            codeReader = new ZXing.BrowserQRCodeReader();
          }
          const stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: "environment" },
          });
          videoRef.current.srcObject = stream;
          videoRef.current.play();

          var interval = setInterval(() => {
            if (videoRef.current.videoHeight > 0) {
              videoRef.current.width = videoRef.current.videoWidth;
              videoRef.current.height = videoRef.current.videoHeight;

              clearInterval(interval);

              codeReader.decodeFromStream(
                stream,
                videoRef.current,
                (result, err) => {
                  if (result && result.text) {
                    const stream = videoRef.current.srcObject;
                    const tracks = stream.getTracks();
                    tracks.forEach((track) => track.stop());
                    videoRef.current.srcObject = null;
                    onCapture(result.text);
                  }
                }
              );
            }
          }, [10]);
        } catch (err) {
          console.error("Error accessing camera or starting ZXing:", err);
        }
      };

      startScanning();
    }
  }, [zxingReady, ZXing, config, onCapture]);

  if (error) {
    return <p>Error loading ZXing-JS: {error}</p>;
  }

  return (
    <div>
      {!zxingReady ? (
        <p>Cargando Lector...</p>
      ) : (
        <video
          ref={videoRef}
          id="videoElement"
          width="640"
          height="480"
          autoPlay
          playsInline
          muted
        ></video>
      )}
      {/* Display barcode value or other UI elements */}
    </div>
  );
}

export default CodeScannerZXing;
